import React from "react";

const AmenityRow = ({ icon, name, value, italic }) => (
    <div className="aircraft-card-extra-content__amenity">
        <img src={icon} alt="" className="aircraft-card-extra-content__amenity-icon" />
        <span className="aircraft-card-extra-content__amenity-name">{italic ? <em>{name}</em> : name}</span>
        <span className="aircraft-card-extra-content__amenity-value">{italic ? <em>{value}</em> : value}</span>
    </div>
);

export default AmenityRow;
